import { HostBinding, Component, OnInit } from '@angular/core';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from '../../../environments/environment';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './sobre.component.html',
  styleUrls: ['./sobre.component.scss'],
  animations: [routerTransition],
})
export class SobreComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  environment = environment;

  mapaCentralizado = { lng: -44.9977998, lat: -3.9719845, zoom: 7 };

  mapaCentralizadoEuro = { lng: -47.8951148, lat: -15.6961266, zoom: 10 };

  mapaCentralizadoFamaz = { lng: -48.4931563, lat: -1.4418987, zoom: 12 };

  mapaCentralizadoCesup = { lng: -48.3361328, lat: -10.2586479, zoom: 12 };

  // !2d
  mapaLocalidades = [
    ['Campus Renascença', -2.5031216, -44.2842976, 1],
    ['Campus Cohama', -2.5209127, -44.2460599, 2],
    ['Campus Anil', -2.5531112, -44.2501645, 3],
    ['Campus Imperatriz', -5.5140118, -47.4727022, 4],
    ['Campus Bacabal', -4.2404872, -44.7918504, 5],
    ['Campus Turu', -2.5297641, -44.2257956, 6],
  ];

  polosMapaLocalidades = [
    ['Polo Renascença', -2.5031216, -44.2842976, 1],
    ['Polo Rio Anil', -2.5338180160773, -44.22478453638306, 2],
    ['Polo Imperatriz', -5.5140118, -47.4727022, 3],
    ['Polo Bacabal', -4.2404872, -44.7918504, 4],
    ['Polo Famaz', -1.4418987, -48.495345, 5],
    ['Polo CEUPI (Teresina)', -5.07831339826127, -42.78761351609344, 6],
    ['Polo CEUPI (Parnaíba)', -2.908617406721088, -41.76397400438968, 7],
    ['Polo CESUP', -10.254538507371159, -48.332274875593484, 8],
    ['Polo UNIEURO (Águas Claras)', -15.7864477, -48.039826, 9],
    ['Polo UNIEURO (Asa Sul)', -15.8470233, -47.9306593, 10],
  ];

   // !2d
   mapaLocalidadesEuro = [
    ['Asa Sul', -15.8470233, -47.9306593, 13.5],
    ['Águas Claras', -15.7864477, -48.039826, 12],
  ];

  // !2d
  mapaLocalidadesFamaz = [
    ['Asa Norte', -1.4418987, -48.495345, 1],
  ];

  mapaLocalidadesCesup = [
    ['Cesup', -1.2586479, -1.3361328,13, 1],
  ];

  carrosselImagens = [
    { src: '/assets/images/banners/universidade-1.jpg', title: 'Campus Renascença em São Luís' },
    { src: '/assets/images/banners/universidade-2.jpg', title: 'Laboratórios Universidade Ceuma' },
    { src: '/assets/images/banners/universidade-4.jpg', title: 'Cerimônia de graduação na universidade Ceuma' },
    { src: '/assets/images/banners/universidade-5.jpg', title: 'Cerimônia de graduação na universidade Ceuma' },
  ];

  carrosselImagensEuro = [
    { src: '/assets/images/banners/x.jpg', title: 'Foto 1' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 2' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 3' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 4' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 5' },
  ];

  carrosselImagensFamaz = [
    { src: '/assets/images/banners/x.jpg', title: 'Foto 1' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 2' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 3' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 4' },
    { src: '/assets/images/banners/x.jpg', title: 'Foto 5' },
  ];

  constructor() { }

  ngOnInit() { }
}
